import React from "react";
import PropTypes from "prop-types";
import infoIcon from "icons/info-new-rows.svg";

const InfoCard = ({ left, right, info }) => (
  <div className="info__card" data-testid="info-card">
    <div className="info__card__left">{left}</div>
    <div className="info__card__right">{right}</div>
    {info !== undefined && (
      <img
        className="info__card__icon"
        src={infoIcon}
        alt="info"
        title={info}
      />
    )}
  </div>
);

export default InfoCard;

InfoCard.propTypes = {
  left: PropTypes.element.isRequired,
  right: PropTypes.element.isRequired,
  info: PropTypes.string,
};
